const HEADER_SELECTOR = '#site-header';
const BLOG_TAGS_SELECTOR = '[data-scroll-target="blog-tags"]';
const TAGGED_PATH_RE = /\/tagged\//;

const getHeaderOffset = () => {
  if (window.innerWidth >= 1280) return 160;
  return 80;
};

const getScrollBehavior = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

const scrollToElement = (element) => {
  if (!element) return;
  const headerOffset = getHeaderOffset();
  const elementTop = element.getBoundingClientRect().top + window.scrollY;
  const targetTop = Math.max(elementTop - headerOffset, 0);

  window.scrollTo({
    top: targetTop,
    behavior: getScrollBehavior(),
  });
};

const scrollToHash = (hash) => {
  if (!hash || hash === '#') return;
  const id = decodeURIComponent(hash.slice(1));
  const target = document.getElementById(id) || document.querySelector(`[name="${id}"]`);
  scrollToElement(target);
};

document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]');
  if (!link) return;

  const { hash, origin, pathname } = link;
  if (!hash || origin !== window.location.origin) return;
  if (pathname !== window.location.pathname) return;

  const id = decodeURIComponent(hash.slice(1));
  const target = document.getElementById(id) || document.querySelector(`[name="${id}"]`);
  if (!target) return;

  event.preventDefault();
  if (hash !== window.location.hash) {
    history.pushState(null, '', hash);
  }
  scrollToElement(target);
});

window.addEventListener('load', () => {
  if (TAGGED_PATH_RE.test(window.location.pathname)) {
    const target = document.querySelector(BLOG_TAGS_SELECTOR);
    scrollToElement(target);
    return;
  }

  scrollToHash(window.location.hash);
});

